interface IconProps {
  color?: string;
  className?: string;
}

export default function StatesIcon({
  color = "#8E929E",
  className = "",
}: IconProps) {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="0.5"
        y="0.5"
        width="23.5321"
        height="23.5321"
        rx="4.5"
        stroke={color}
      />
      <g clipPath="url(#clip0_6675_62288)">
        <path
          d="M13.0852 6.68103L14.9182 9.54759L18.2094 10.4032C18.6653 10.5218 18.8433 11.0745 18.5467 11.4368L16.3858 14.066L16.5888 17.4634C16.6169 17.9349 16.1485 18.2753 15.7082 18.1036L12.5419 16.8608L9.37553 18.1036C8.93836 18.2753 8.46685 17.9349 8.49495 17.4634L8.69792 14.066L6.53707 11.4399C6.2373 11.0745 6.41841 10.525 6.87431 10.4063L10.1656 9.55071L11.9985 6.68415C12.2515 6.28758 12.8323 6.28758 13.0852 6.68415V6.68103Z"
          stroke={color}
          strokeMiterlimit="10"
        />
      </g>
      <defs>
        <clipPath id="clip0_6675_62288">
          <rect
            width="13.0838"
            height="12.5436"
            fill="white"
            transform="translate(6 5.99414)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
